import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-diagnostic-fdrs-view',
  templateUrl: './diagnostic-fdrs-view.component.html',
  styleUrls: ['./diagnostic-fdrs-view.component.scss']
})
export class DiagnosticFdrsViewComponent implements OnInit, AfterViewChecked {
  public getApiRes: any;
  public type = '';
  public id = '';
  public uid = '';
  public showSuggest = false;
  public componentPost: any;
  public componentId = '';
  public language = '';
  public country = '';
  public symptomList = '';
  public vehicleModel = '';
  public market = '';
  public invinnumber: any;
  public res: any;
  public submitRes: any;
  public isShow = false;
  public userId: any;
  public username: any;
  public userType: any;
  public TEPostRepairDetails: any;
  public TEDescDetails: any = [];
  public iserr = false;
  public candidateId = '';
  public candidateKind = '';
  public candidateProcUid = '';
  public sessionId: any;
  public testRes: any;
  public ruleId = '';
  public isFDRSConnected = false;
  public selectedFaultString: string = '';
  public apiresp: any;
  public uid1: any;
  public selectedValue: any;
  public displayHTML: any = '';
  public viewContent: boolean = false;
  public getHTMLData: boolean = false;
  public resume = false;
  public notFromResume = false;
  public nextResume = true;
  public captureOtxStateChange:any = [{}];
  public selectedProcedureId: string='';
  countViewChecked: number = 0;
  viewDiagnosticCandidate: boolean = false;
  otxDataSubscription: Subscription = new Subscription;
  resumeSubscription: Subscription = new Subscription;
  //public intialCandidateArray:any;
  image: any;
  imageUrl: any;
  newPath: any;
  oldPath: any;
  newcontent:boolean = false;
  constructor(private service: ApifirstService, private modalService: NgbModal, private router: Router, private translate: TranslateService, private activateRoute: ActivatedRoute,private sanitizer: DomSanitizer,private spinnerService: NgxSpinnerService ) { }

  ngOnInit(): void {
    this.service.isShowRAP.next(false);
    this.sessionId = localStorage.getItem("sessionID")
    this.resumeSubscription = this.service.fromResume.subscribe(data => this.resume = data);
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    this.service.candidateId.subscribe((data) => {
      this.candidateId = data
    })

    this.service.isFDRSConnection.subscribe((data) => {
      this.isFDRSConnected = data;
    })

    this.service.candidateKind.subscribe((data) => {
      this.candidateKind = data
    })

    this.service.candidateProcUid.subscribe((data) => {
      this.candidateProcUid = data
    })

    // this.service.getViewDetailsofFDRSAPI(this.candidateId, this.sessionId).subscribe((data) => {
    //   this.testRes = data
    //   this.ruleId = this.testRes.id;
    //   // this.getTableOfView(this.ruleId);
    // })

    this.service.tokenObj.subscribe((data) => {
      this.res = data;
      this.country = this.res.country;
      this.language = this.res.language;
      this.market = this.res.marketCountry
      this.invinnumber = this.res.vin
      this.username = this.res.username
      this.userType = this.res.userType
    })

    //this.getTableOfView(this.candidateId);
   
      // if (this.candidateKind == 'TSB-CANDIDATE') {
      //   this.getTableOfViewTSB(this.candidateProcUid)
      // } else {
        this.getTableOfView(this.candidateId);
      // }
    

    this.service.getTEPostRepairDetails(this.invinnumber, this.country, this.language, this.userId, this.username, this.userType, this.sessionId).subscribe((data) => {
      this.TEPostRepairDetails = data
      this.selectedValue = this.TEPostRepairDetails[0];
    })

    this.otxDataSubscription = this.service.otxStateChangeObj.subscribe((data)=> {
      this.captureOtxStateChange = data;
      console.log("captureStateChange:", this.captureOtxStateChange);
    })

    this.service.getSelectedDiagProcdureId.subscribe((data)=> {
      this.selectedProcedureId = data;
    })

    //resume

    // if (this.resume && !this.notFromResume) {
    //   this.service.pageData.subscribe(data => {
    //     this.getApiRes = data;
    //     this.displayHTML = this.getApiRes.htmloutput;
    //   })
    // }
    // if (this.resume && !this.notFromResume && this.nextResume) {
    //   this.service.pageData.subscribe(data => {
    //     this.getApiRes = data;
    //     this.displayHTML = this.getApiRes.htmloutput;
    //   })
    // }
    //resume
  }

  ngAfterViewChecked() {
    if(this.displayHTML && this.countViewChecked == 0) {
      this.countViewChecked++;
      const pinpointLinks = document.querySelectorAll("a[href]");
      const buttonLinks = document.querySelectorAll("input[onclick]");
      pinpointLinks.forEach(link => {
        let href: any = link.getAttribute('href');
        let extras: NavigationExtras = {
          relativeTo: this.activateRoute,
          queryParamsHandling: 'merge',
        };
        if(href[0]=='#' || href=='') {
          extras.queryParams = this.activateRoute.snapshot.params;
          if(href[0]=='#'){
            extras.fragment = href.slice(1);
          }
          link.addEventListener('click', ()=>{
            this.router.navigate([],extras);
          });
        }else if(href[0]== 'G' || href[0]=='p') {
          // do nothing
        }else {
          const query: any[] = href.split('?');
          let params = JSON.parse('{"' + decodeURI(query[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
          extras.queryParams = params;
          link.addEventListener('click', ()=>{
            this.service.getViewDetailsofFDRSRedirect(href).subscribe((data)=>{
              this.countViewChecked = 0;
              this.getApiRes = data;
              this.testHtml();
              this.router.navigate([],extras);
            })
          });
        }
        link.setAttribute('href','javascript:void(0)');
      })
      buttonLinks.forEach(link => {
        link.setAttribute('onclick','javascript:void(0)');
      })
      const headers = document.querySelectorAll("th");
      headers.forEach(header => header.setAttribute('style','border-width: 1px'));
      const tableData = document.querySelectorAll("td[valign='top']");
      for(let i=0; i<tableData.length; i++){
        let childNodeLength: number;
        let row: number = i%3;
        if(row == 0){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length,tableData[i+2].childNodes.length);
        }else if(row == 1){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length);
        }else{
          childNodeLength = tableData[i].childNodes.length;
        }
        let style = tableData[i].getAttribute('style');
        if(childNodeLength == 0){
          if(style){
            tableData[i].setAttribute('style',style);
          }
        }else{
          if(style){
            tableData[i].setAttribute('style',tableData[i].getAttribute('style')+' border-width: 1px');
          }else{
            tableData[i].setAttribute('style','border-width: 1px');
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.service.isShowRAP.next(true);
    this.otxDataSubscription.unsubscribe();
    this.resumeSubscription.unsubscribe();
  }

  reportAProblemPopup() {
    if (1 == 1) {
      this.service.sendGnumberToRAP.next(this.candidateId);
      const modalRef = this.modalService.open(ReportAProblemPageComponent, {
        windowClass: "myCustomModalClass",
        backdrop: 'static'
      });
      modalRef.result.then(
        result => {
          console.log(result);
        },
        reason => { }
      );
    }
  }

  getTableOfView(id: string) {
    let printText: string = this.translate.instant('Print');
    this.service.getViewDetailsofFDRS(id, this.language, this.country, this.market, "SPA", printText,this.username,this.userType).subscribe((data) => {
      this.getApiRes = data;
      this.testHtml();

    })
  }

  faultPopup(delContent: any) {
    localStorage.setItem("manualDiagBtnClick", " ");
    this.modalService.open(delContent, { centered: true })
  }

  testHtml() {
    this.viewContent = true;
    this.displayHTML = this.getApiRes;
    this.extractImgSrc(this.displayHTML);
    if(this.displayHTML) {
      this.getHTMLData = true;
    }else {
      this.getHTMLData = false;
    }
  }

  callGetImage(url:any) {
    this.service.getImage(url).subscribe((res:any) => {
      let objectURL = URL.createObjectURL(res);       
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL)
      this.imageUrl = this.image.changingThisBreaksApplicationSecurity;


      this.newPath.push( {
          'oldpath': url,
          'newpath':  this.imageUrl
    });
    if (this.oldPath.length == this.newPath.length) {
      this.newPath.forEach((element:any) => {
        this.displayHTML = this.displayHTML.replaceAll(element.oldpath, element.newpath)
      });
      this.newcontent = true;
      this.spinnerService.hide();
    }
    });
  }


  extractImgSrc(htmlString: string) {
    this.spinnerService.show();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const images = doc.getElementsByTagName('img');
    this.oldPath = [];
    this.newPath = [];
    for (let i = 0; i < images.length; i++) {
      let imgSrc = images[i].src;
      if (imgSrc.startsWith('https')) {
        this.oldPath.push(imgSrc);
        this.callGetImage(imgSrc);
      }
    } 
    if(this.oldPath.length == 0) {
      this.newcontent = true;
      this.displayHTML = htmlString;
      this.spinnerService.hide();
    }
  }

  noFaultPopup() {
    localStorage.setItem("manualDiagBtnClick", " ");
    this.viewDiagnosticCandidate = true;
    let req = {
      "sessionId": this.sessionId,
      "faultFoundValue": "false",
      "faultComponentGNumber": "",
      "pageState": "DIAGNOSTIC",
      "vin": this.invinnumber,
      "userId": this.username,
      "userType": this.userType,
      "languageCode": this.language,
      "countryCode": this.country
    }

    if(!this.getHTMLData) {
      req["faultFoundValue"] = "Error";
    }

    this.service.noFaultButtonClick(req).subscribe((data)=> {
      this.viewDiagnosticCandidate = false;
      console.log('diagnostic nofault:', data);
      this.router.navigate(["/info"]);
    })

    let obj = {
      "status": 'noFault',
      "isFound": false,
      "faultString": ''
    }
    this.service.diagnosticViewFaultFound.next(obj);

    for (let obj of this.captureOtxStateChange) {
      if (obj.id == this.selectedProcedureId) {
        obj.isCheckBoxDisable = true;
        console.log('********', obj);
        obj.state = 'Pass - no Fault';
        if (!this.getHTMLData) {
          obj.state = 'Error';
        } else if (obj.kind == 'PINPOINT-CANDIDATE') {
          obj.state = 'Viewed';
        }
        break;
      }
    }
    this.service.fromResume.next(false);
    this.service.otxStateChangeObj.next(this.captureOtxStateChange);
    this.service.pageData.next('');
  }

  continue() {
    this.viewDiagnosticCandidate = true;
    let userObj = {
      userId: this.username,
      userType: this.userType,
      languageCode: this.language,
      countryCode: this.country,
      vin: this.invinnumber,
      componentNumber: this.selectedValue.uid,
      sessionid: this.sessionId
    }
    this.service.passApiResp.next(userObj);
    let req = {
      "sessionId": this.sessionId,
      "faultFoundValue": "true",
      "faultComponentGNumber": this.selectedValue.gnumber,
      "pageState": "DIAGNOSTIC",
      "vin": this.invinnumber,
      "userId": this.username,
      "userType": this.userType,
      "languageCode": this.language,
      "countryCode": this.country
    }
    this.service.faultFoundButtonClick(req).subscribe((data)=> {
      this.viewDiagnosticCandidate = false;
      console.log('diagnostic Fault:', data);
      this.router.navigate(["/info"]);
    })

    let obj = {
      "status": 'fault',
      "isFound": true,
      "faultString": this.selectedValue.description
    }
    this.service.diagnosticViewFaultFound.next(obj);

    for (let obj of this.captureOtxStateChange) {
      if (obj.id == this.selectedProcedureId) {
        console.log('********', obj);
        obj.state = 'fail - Fault found';
        break;
      }
    }
    this.service.fromResume.next(false);
    this.service.otxStateChangeObj.next(this.captureOtxStateChange);
    this.service.pageData.next('');
  }
}
